// Top-level field names of a GraphQL document (`{ a: lots { id } leads }` →
// ["lots", "leads"]): aliases resolve to the field, arguments and nested
// selections are skipped. Best effort — only used to label a step.
export const rootFieldsOf = (operation: string): Array<string> => {
  const src = operation
    .replace(/"""[\s\S]*?"""/g, '""')
    .replace(/"(?:[^"\\]|\\.)*"/g, '""')
    .replace(/#[^\n]*/g, '');
  const fields: Array<string> = [];
  let depth = 0;
  let parens = 0;
  let i = 0;
  while (i < src.length) {
    const ch = src[i];
    if (ch === '(') {
      parens += 1;
    } else if (ch === ')') {
      parens -= 1;
    } else if (parens === 0 && ch === '{') {
      depth += 1;
    } else if (parens === 0 && ch === '}') {
      depth -= 1;
    } else if (parens === 0 && depth === 1 && /[A-Za-z_]/.test(ch)) {
      const name = /^[A-Za-z_]\w*/.exec(src.slice(i))?.[0] ?? '';
      i += name.length;
      const alias = /^\s*:\s*([A-Za-z_]\w*)/.exec(src.slice(i));
      if (alias != null) {
        i += alias[0].length;
      }
      const field = alias?.[1] ?? name;
      if (!fields.includes(field) && field !== '__typename') {
        fields.push(field);
      }
      continue;
    }
    i += 1;
  }
  return fields;
};
